import * as runtime from '@/api/runtime'
import {
  BatchTrcContentDataUpdateRequest,
  BatchTrcContentDataUpdateRequestToJSON,
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api/models/batch'
import {
  BatchTrcContentDataUpdateCondition,
  BatchTrcContentDataUpdateConditionFromJSON
} from '@/api/models/batch/BatchTrcContentDataUpdateCondition'

/**
 * 帳票作成
 */
export class BatchTrcContentDataUpdateApi extends runtime.BaseAPI {
  async update(request: BatchTrcContentDataUpdateRequest): Promise<number> {
    const response = await this.requestPost(
      `/batch/bibliography/trc-content-data-update`,
      BatchTrcContentDataUpdateRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async getInitialCondition(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchTrcContentDataUpdateCondition> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchTrcContentDataUpdateConditionFromJSON(jsonValue)
    ).value()
  }
}
